import { render, staticRenderFns } from "./DynamicFactoid.vue?vue&type=template&id=6a060b54&"
import script from "./DynamicFactoid.vue?vue&type=script&lang=js&"
export * from "./DynamicFactoid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports